import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 36, className }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const RevealImage = ({ src, alt, className, delay = 0 }) => (
    <motion.div
        initial={{ clipPath: "inset(8% 6% 8% 6%)", opacity: 0.4 }}
        whileInView={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1.2, delay, ease: EASE }}
        className={`overflow-hidden ${className || ""}`}
    >
        <motion.img
            src={src}
            alt={alt}
            loading="lazy"
            initial={{ scale: 1.12 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.6, delay, ease: EASE }}
            className="h-full w-full object-cover"
        />
    </motion.div>
);

export const SectionMark = ({ children, light }) => (
    <p
        className={`text-[11px] font-medium uppercase tracking-[0.4em] ${
            light ? "text-[#7a6748]" : "text-bronze"
        }`}
    >
        {children}
    </p>
);
